{{ formattedPrice() }}
